/**
 * Which of the two apps (office / Feldaufnahme) the user was in last, so the
 * root path can send them back there instead of always to the office. Written
 * by each layout on mount, so it reflects where they were, not where they last
 * tapped a switch button.
 */

import { defineStoredString } from './storage';

export type AppArea = 'office' | 'field';

// `allow` does the guarding: anything else in there is from a hand-edit or an
// older version, and reads as "never been anywhere".
const lastAppValue = defineStoredString<AppArea>({
    key: 'last_app',
    allow: ['office', 'field']
});

export function rememberApp(area: AppArea): void {
    // Storage disabled: the root path just falls back to its default.
    lastAppValue.write(area);
}

export function lastApp(): AppArea | null {
    return lastAppValue.read();
}
